jQuery(".accordion_lista .accordion_lista__title").on("click", function() {
  console.log('sisiis');
  const content = jQuery(this)
    .closest(".accordion_lista__item");

  const className = "accordion_lista__item--open";

  if (content.hasClass(className)) {
    content
      .removeClass(className)
      .find(".accordion_lista__content").slideUp();
  } else {
    content
      .addClass(className)
      .find(".accordion_lista__content").slideDown();
  }
});
